import styled from '@emotion/styled'
import {theme} from '../../../../theme'

// ─── Toggle button group (Bill to, Sales rep, SST) ───────────────────────────

export const FullWidth = styled.div`
  grid-column: 1 / -1;
`

export const ToggleGroup = styled.div`
  // display: inline-flex;
  // border-radius: ${theme.radii.lg};
  // overflow: hidden;
  // border: 1px solid ${theme.colors.border.default};
  // width: max-content;
  display: inline-flex;
  align-items: center;

  padding: 5px;
  gap: 10px;

  border-radius: 5px;
  background: #e1eaff;

  width: fit-content;
  hieght: 50px;

  opacity: ${({disabled}) => (disabled ? 0.55 : 1)};
  pointer-events: ${({disabled}) => (disabled ? 'not-allowed' : 'pointer')};
`

export const ToggleButton = styled.button`
  border: none;
  outline: none;
  display: flex;
  background: ${({isActive}) => (isActive ? '#ffffff' : 'transparent')};

  color: ${({isActive}) => (isActive ? '#111827' : '#4b5563')};

  font-size: 14px;
  font-weight: ${({isActive}) => (isActive ? 600 : 500)};

  padding: 10px 18px;

  border-radius: 10px;

  cursor: pointer;

  transition: background 180ms ease, color 180ms ease, box-shadow 180ms ease;

  box-shadow: ${({isActive}) =>
    isActive
      ? '0 1px 2px rgba(0,0,0,0.08), 0 1px 6px rgba(0,0,0,0.04)'
      : 'none'};

  white-space: nowrap;

  &:hover {
    color: #111827;
  }
`

export const QuestionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[2]};
`

export const QuestionLabel = styled.p`
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.text.primary};
  // color: #5f6b7a;
  margin: 0;
`

export const TwoColumnQuestions = styled.div`
  display: grid;
  // grid-template-columns: 1fr 1fr;
  // gap: ${theme.space[5]};
  // margin-top: ${theme.space[6]};
`

export const DependentFieldWrapper = styled.div`
  margin-top: 16px;
  width: 100%;
`
